import createSyncedBalancesAtom from './synced-balances.js'

export const syncedBalancesAtomDefinition = {
  id: 'syncedBalancesAtom',
  factory: createSyncedBalancesAtom,
  dependencies: [],
  type: 'atom',
  public: true,
}
